<template>
  <div class="mb-6">
    <div class="mb-4 flex flex-wrap items-center gap-2">
      <h5><i class="dot"></i><slot name="title">{{title}}</slot></h5>
      <div class="ml-auto">
        <slot name="right"></slot>
      </div>
    </div>
    <div class="grid xl:grid-cols-12">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "MaotSection",
  props: {
    title: String,

  },
}
</script>

<style scoped lang="scss">

</style>
